// @ts-nocheck
import React, { useState } from "react";
import { Link } from "react-router-dom";

// ── Design tokens (mirrors App.jsx) ──────────────────────────
const C = {
  navy:      "#04080f",
  navyMid:   "#080e1a",
  navyLight: "#0e1828",
  navyRim:   "#1e3055",
  accent:    "#e8ff47",
  white:     "#f4f6fa",
  muted:     "#6b7fa3",
  mid:       "#8da3c4",
  border:    "rgba(255,255,255,0.07)",
  borderM:   "rgba(255,255,255,0.11)",
};

const inputStyle = {
  width: "100%",
  background: C.navyLight,
  border: `1px solid ${C.borderM}`,
  borderRadius: "8px",
  padding: "12px 16px",
  color: C.white,
  fontFamily: "'DM Mono', monospace",
  fontSize: "13px",
  letterSpacing: "0.04em",
  outline: "none",
  boxSizing: "border-box",
};

const labelStyle = {
  display: "block",
  fontFamily: "'DM Mono', monospace",
  fontSize: "9.5px",
  letterSpacing: "0.22em",
  textTransform: "uppercase",
  color: C.muted,
  marginBottom: "8px",
};

const optionalBadge = {
  fontFamily: "'DM Mono', monospace",
  fontSize: "8.5px",
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: C.navyRim,
  background: "rgba(255,255,255,0.05)",
  border: `1px solid ${C.border}`,
  borderRadius: "4px",
  padding: "2px 6px",
  marginLeft: "8px",
  verticalAlign: "middle",
};

function Field({ label, required, children }) {
  return (
    <div>
      <label style={{ ...labelStyle, marginBottom: "8px" }}>
        {label}
        {!required && <span style={optionalBadge}>optional</span>}
      </label>
      {children}
    </div>
  );
}

export default function RequestBike() {
  const [brand, setBrand]       = useState("");
  const [model, setModel]       = useState("");
  const [year, setYear]         = useState("");
  const [link, setLink]         = useState("");
  const [email, setEmail]       = useState("");
  const [notes, setNotes]       = useState("");
  const [honeypot, setHoneypot] = useState("");
  const [status, setStatus]     = useState("idle"); // idle | submitting | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("submitting");
    try {
      const res = await fetch("/api/request-bike", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ brand, model, year, link, email, notes, website: honeypot }),
      });
      setStatus(res.ok ? "success" : "error");
    } catch {
      setStatus("error");
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: C.navy, color: C.white }}>
      {/* ── NAV ── */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "20px 32px",
        borderBottom: `1px solid ${C.border}`,
      }}>
        <Link
          to="/"
          style={{ fontFamily: "'DM Mono', monospace", fontSize: "13px", letterSpacing: "0.06em", textDecoration: "none", display: "inline-flex", alignItems: "center" }}
        >
          <span style={{ color: C.white }}>newbikeday</span>
          <span style={{ color: C.accent }}>.fit</span>
        </Link>
        <Link
          to="/bike-fit-calculator"
          style={{ fontFamily: "'DM Mono', monospace", fontSize: "10px", letterSpacing: "0.16em", textTransform: "uppercase", color: C.muted, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "6px", transition: "color 0.15s ease" }}
          onMouseEnter={(e) => { e.currentTarget.style.color = C.accent; }}
          onMouseLeave={(e) => { e.currentTarget.style.color = C.muted; }}
        >
          &larr; Calculator
        </Link>
      </div>

      {/* ── CONTENT ── */}
      <div style={{ maxWidth: "640px", margin: "0 auto", padding: "0 24px 80px" }}>

        {/* Page header */}
        <div style={{ textAlign: "center", padding: "48px 0 40px" }}>
          <div style={{
            fontFamily: "'DM Mono', monospace",
            fontSize: "9.5px",
            letterSpacing: "0.26em",
            textTransform: "uppercase",
            color: C.accent,
            marginBottom: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
          }}>
            <span style={{ width: "24px", height: "1px", background: C.accent, opacity: 0.4, display: "inline-block" }} />
            Database
            <span style={{ width: "24px", height: "1px", background: C.accent, opacity: 0.4, display: "inline-block" }} />
          </div>
          <h1 style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: "clamp(42px, 8vw, 72px)",
            letterSpacing: "0.03em",
            lineHeight: 0.9,
            color: C.white,
            margin: "0 0 20px",
          }}>
            Request a Bike
          </h1>
          <p style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "14px",
            lineHeight: 1.75,
            color: C.muted,
            fontWeight: 300,
            margin: 0,
          }}>
            Can't find your bike? Let us know and we'll add its geometry to the database.
          </p>
        </div>

        {/* ── FORM CARD ── */}
        {status === "success" ? (
          <div style={{
            background: C.navyMid,
            border: `1px solid ${C.border}`,
            borderRadius: 0,
            padding: "48px 32px",
            textAlign: "center",
          }}>
            <p style={{
              fontFamily: "'DM Mono', monospace",
              fontSize: "11px",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: C.accent,
              marginBottom: "12px",
            }}>
              Request sent
            </p>
            <p style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: "15px",
              lineHeight: 1.7,
              color: C.white,
              fontWeight: 300,
              marginBottom: "32px",
            }}>
              Thanks! Your request has been sent.
            </p>
            <Link
              to="/bike-fit-calculator"
              style={{
                fontFamily: "'DM Mono', monospace",
                fontSize: "11px",
                letterSpacing: "0.14em",
                textTransform: "uppercase",
                color: C.accent,
                textDecoration: "none",
                border: `1px solid ${C.accent}`,
                padding: "10px 20px",
                display: "inline-block",
                transition: "all 0.15s ease",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(232,255,71,0.08)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
            >
              Back to calculator
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{
              background: C.navyMid,
              border: `1px solid ${C.border}`,
              borderRadius: 0,
              padding: "32px",
              display: "flex",
              flexDirection: "column",
              gap: "24px",
            }}>
              <Field label="Bike brand" required>
                <input
                  style={inputStyle}
                  type="text"
                  placeholder="e.g. Specialized"
                  value={brand}
                  onChange={(e) => setBrand(e.target.value)}
                  required
                />
              </Field>

              <Field label="Bike model" required>
                <input
                  style={inputStyle}
                  type="text"
                  placeholder="e.g. Tarmac SL8"
                  value={model}
                  onChange={(e) => setModel(e.target.value)}
                  required
                />
              </Field>

              <Field label="Model year">
                <input
                  style={inputStyle}
                  type="text"
                  inputMode="numeric"
                  placeholder="e.g. 2024"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                />
              </Field>

              <Field label="Manufacturer or geometry page">
                <input
                  style={inputStyle}
                  type="url"
                  placeholder="https://..."
                  value={link}
                  onChange={(e) => setLink(e.target.value)}
                />
              </Field>

              <Field label="Your email">
                <input
                  style={inputStyle}
                  type="text"
                  inputMode="email"
                  autoComplete="email"
                  placeholder="so we can let you know when it's added"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Field>

              <Field label="Notes">
                <textarea
                  style={{ ...inputStyle, resize: "vertical", minHeight: "88px", lineHeight: 1.6 }}
                  placeholder="Anything else that might help (size range, variant, etc.)"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </Field>

              {/* Honeypot — hidden from real users, bots fill it in */}
              <input
                type="text"
                name="website"
                value={honeypot}
                onChange={(e) => setHoneypot(e.target.value)}
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                style={{ position: "absolute", left: "-9999px", width: "1px", height: "1px", opacity: 0 }}
              />

              {status === "error" && (
                <p style={{
                  fontFamily: "'DM Mono', monospace",
                  fontSize: "11px",
                  letterSpacing: "0.08em",
                  color: "#fca5a5",
                  margin: 0,
                }}>
                  Something went wrong. Please try again or email us at hello@newbikeday.fit.
                </p>
              )}

              <button
                type="submit"
                disabled={status === "submitting"}
                style={{
                  width: "100%",
                  padding: "16px",
                  background: status === "submitting" ? "rgba(232,255,71,0.4)" : C.accent,
                  color: C.navy,
                  border: "none",
                  borderRadius: 0,
                  fontFamily: "'DM Mono', monospace",
                  fontSize: "11px",
                  letterSpacing: "0.2em",
                  textTransform: "uppercase",
                  fontWeight: "600",
                  cursor: status === "submitting" ? "not-allowed" : "pointer",
                  transition: "opacity 0.15s ease",
                }}
              >
                {status === "submitting" ? "Sending…" : "Send request"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
